<nav-menu [isLoggedIn]="loggedIn"></nav-menu>
<record-lock-modal></record-lock-modal>
<spinner></spinner>
<main class="container-fluid">
    <!--<div class='row'>
        <div [ngClass]="{'navigation-container': isExpanded, 'small-navigation-container': !isExpanded}">
            <div>
                <nav-menu [isExpanded]="isExpanded"></nav-menu>
            </div>
            <div [ngClass]="{'nav-footer': isExpanded, 'small-nav-footer': !isExpanded}">
                <span *ngIf="isExpanded" style="float: right; cursor: pointer;" (click)="isExpanded = false">&laquo;&laquo;</span>
                <span *ngIf="!isExpanded" style="float: right; cursor: pointer;" (click)="isExpanded = true">&raquo;&raquo;</span>
            </div>
        </div>
        <div [ngClass]="{'main-container': isExpanded, 'large-main-container': !isExpanded}" class='body-content'>
            <router-outlet></router-outlet>
        </div>
    </div>-->
    <router-outlet *ngIf="!isIframe"></router-outlet>
</main>
